import { StorageService } from "../../../services/storage.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { finalize, map, shareReplay } from "rxjs/operators";
import { Uris } from "../../../services/Uris";

@Injectable({
  providedIn: "root"
})
export class VersioningService {
  constructor(
    public storageService: StorageService,
    private http: HttpClient,
    public router: Router
  ) {}

  // Peticion en curso de la ultima version; header y offsidebar la piden al mismo tiempo
  private lastVersion$: Observable<any> | null = null;

  /**
   * Obtiene la ultima version publicada. Si ya hay una peticion en curso se comparte
   * en lugar de hacer otra; al terminar, la siguiente llamada vuelve a consultar.
   * @returns Observable con la respuesta paginada de versiones.
   */
  getLastVersion(): Observable<any> {
    if (this.lastVersion$) return this.lastVersion$;
    let query = "?page_size=1&ordering=-id";

    this.lastVersion$ = this.http
      .get(`${Uris.VERSIONING}${query}`, this.storageService.headers())
      .pipe(
        finalize(() => {
          this.lastVersion$ = null;
        }),
        shareReplay({ bufferSize: 1, refCount: true })
      );
    return this.lastVersion$;
  }

  getVersions(query: any) {
    return this.http.get(`${Uris.VERSIONING}${query}`, this.storageService.headers()).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  postVersion(object: any) {
    return this.http.post(`${Uris.VERSIONING}`, object, this.storageService.headers()).pipe(
      map((resp: any) => {
        this.storageService.animation("success", "Éxito", `Versión creada correctamente`);
        return resp;
      })
    );
  }

  deleteVersion(id: number) {
    return this.http.delete(`${Uris.VERSIONING}${id}/`, this.storageService.headers()).pipe(
      map((resp: any) => {
        this.storageService.animation("success", "Éxito", `Versión eliminada correctamente`);
        return resp;
      })
    );
  }

  patchVersion(id: number, object: any) {
    return this.http.patch(`${Uris.VERSIONING}${id}/`, object, this.storageService.headers()).pipe(
      map((resp: any) => {
        this.storageService.animation("success", "Éxito", `Versión editada correctamente`);
        return resp;
      })
    );
  }
}
